import { IMenuState } from '../../interfaces/menu';

export const setMenu = (payload: IMenuState) : any => {
    return {
        type: 'SET_MENU',
        payload
    };
};